import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediumUploadDTOAndTags } from 'src/app/models/taggable.model';
import { TagService } from 'src/app/services/tag.service';
import { UtilService } from 'src/app/services/util.service';
import { ResolutionDTO } from '../../../../../services/api/api';
import { MediumUploadDTO } from '../../medium-explorer.component';
import { PermissionService } from '../../../../../services/permission.service';

@Component({
  selector: '[sb-comp-medium-list-entry]',
  templateUrl: './medium-list-entry.component.html',
  styleUrls: ['./medium-list-entry.component.scss'],
  standalone: false,
})
export class MediumListEntryComponent implements OnInit {
  @Input() medium: MediumUploadDTOAndTags;
  @Input() multiSelect: boolean;
  @Input() divNgClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() resolutionOptions: ResolutionDTO[];
  @Input() isInModalContext: boolean;
  @Input() modalType: string;
  @Input() selectedMedias: MediumUploadDTOAndTags[];
  @Input() isInFolderContext: boolean = false;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() dragendEmitter: EventEmitter<any>;
  @Output() dragstartEmitter: EventEmitter<{ event: DragEvent; item: MediumUploadDTOAndTags }>;
  @Output() deleteMedium: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();

  displayNoMatching: boolean;

  animationOptions: any = {
    autoplay: true,
    loop: true,
  };

  constructor(
    public util: UtilService,
    public tagService: TagService,
    public permissionService: PermissionService
  ) {
    this.multiSelect = false;
    this.dragendEmitter = new EventEmitter<any>();
    this.dragstartEmitter = new EventEmitter<{ event: DragEvent; item: MediumUploadDTOAndTags }>();
    this.displayNoMatching = true;
  }

  ngOnInit(): void {
    this.displayNoMatching = this.displayNoMatchingMarker();
  }

  displayNoMatchingMarker(): boolean {
    if (this.medium && this.medium.resolution && this.resolutionOptions && this.resolutionOptions.length > 0) {
      for (const resolution of this.resolutionOptions) {
        if (resolution.id === this.medium.resolution.id) {
          return false;
        }
      }
    }
    return true;
  }

  isMediumInSelectedMedias(medium: MediumUploadDTO): boolean {
    return this.selectedMedias.findIndex(x => x.id === medium.id) !== -1;
  }
}
